import { c as _c } from "react/compiler-runtime";
import type { Entity, Investigation } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
export type InvestigationIdItem = {
  label: string;
  value: string;
};

// Builds the labelled IDs shown in the header's IdDropdown. Entity-derived ids
// (sandbox, external, sv, vault) are skipped when there's no entity attached.
const useInvestigationIdItems = (investigation, entity) => {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "header.ids"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("investigations", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== investigation.investigationId || $[4] !== t1) {
    t2 = {
      label: t1,
      value: investigation.investigationId
    };
    $[3] = investigation.investigationId;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== investigation.parentInvestigationId || $[7] !== t) {
    t3 = investigation.parentInvestigationId ? {
      label: t(_temp2),
      value: investigation.parentInvestigationId
    } : undefined;
    $[6] = investigation.parentInvestigationId;
    $[7] = t;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== investigation.workflowId || $[10] !== t) {
    t4 = investigation.workflowId ? {
      label: t(_temp3),
      value: investigation.workflowId
    } : undefined;
    $[9] = investigation.workflowId;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== investigation.fpId || $[13] !== t) {
    t5 = investigation.fpId ? {
      label: t(_temp4),
      value: investigation.fpId
    } : undefined;
    $[12] = investigation.fpId;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== entity || $[16] !== t) {
    t6 = entity?.sandboxId ? {
      label: t(_temp5),
      value: entity.sandboxId
    } : undefined;
    $[15] = entity;
    $[16] = t;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== entity || $[19] !== t) {
    t7 = entity?.externalId ? {
      label: t(_temp6),
      value: entity.externalId
    } : undefined;
    $[18] = entity;
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== entity || $[22] !== t) {
    t8 = entity?.svId ? {
      label: t(_temp7),
      value: entity.svId
    } : undefined;
    $[21] = entity;
    $[22] = t;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== entity || $[25] !== t) {
    t9 = entity?.vId ? {
      label: t(_temp8),
      value: entity.vId
    } : undefined;
    $[24] = entity;
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t2 || $[28] !== t3 || $[29] !== t4 || $[30] !== t5 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9) {
    t10 = [t2, t3, t4, t5, t6, t7, t8, t9].filter(_temp9);
    $[27] = t2;
    $[28] = t3;
    $[29] = t4;
    $[30] = t5;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  return t10;
};
export default useInvestigationIdItems;
function _temp($) {
  return $.investigation;
}
function _temp2($_0) {
  return $_0.parentInvestigation;
}
function _temp3($_1) {
  return $_1.onboarding;
}
function _temp4($_2) {
  return $_2.fp;
}
function _temp5($_3) {
  return $_3.sandbox;
}
function _temp6($_4) {
  return $_4.external;
}
function _temp7($_5) {
  return $_5.scopedVault;
}
function _temp8($_6) {
  return $_6.vault;
}
function _temp9(item) {
  return item !== undefined;
}